export default {
  title: 'Artigos',
  order_note: 'Nota da encomenda',
};
